import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client'
import reportWebVitals from 'tests/reportWebVitals'
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { IntlContextProvider } from 'configuration/intl-context'
import { AppContextProvider } from 'configuration/app-context'
import { ThemeContextProvider } from 'configuration/theme-context'
import { MembershipContextProvider } from 'configuration/membership-context';
import { ToastContainer } from 'react-toastify';
import { store } from 'utils/redux-store';
import { pdfjs } from "react-pdf"

import * as Sentry from "@sentry/react";
import { constants, GetQueryVariable } from 'utils/webclient';

const App = lazy(() => import("project"))
const HealthIndicatorRouter = lazy(() => import("./health-indicators/router"))

pdfjs.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

if (process.env.NODE_ENV !== "development") {
    console.log = function () { }
}

if(window.location.hostname == constants.allowedHost){
    initSentry();
}

function initSentry() {
    Sentry.init({
        environment: process.env.NODE_ENV,
        dsn: 'https://411ebab60f0a11d1b7500066a04ac7d5@o4508098541322240.ingest.de.sentry.io/4508635490811984',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false, 
                blockAllMedia: false, 
            })
        ],
        tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0, //  Capture 100% of the transactions
        tracePropagationTargets: [],
        replaysSessionSampleRate: process.env.NODE_ENV === "production" ? 0.05 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        normalizeDepth: 10, // This sets the maximum depth for normalization of stack traces.
        sampleRate: 1,
        profilesSampleRate: 1.0,
    });

}

const AppRender = () => {

    const location = window.location.search

    const special_view = GetQueryVariable("special_view", location, null)
    const language_id = GetQueryVariable("language", location, "tr")
    const token = GetQueryVariable("token", location, null)
    const topSpace = GetQueryVariable("top_space", location, 0)

    if (special_view != null && special_view == "HealthIndicators") {
        return (
            <Provider store={store}>
                <IntlContextProvider initialLanguage={language_id.toUpperCase()}>
                    <HealthIndicatorRouter token={token} topSpace={topSpace} />
                </IntlContextProvider>
            </Provider>
        )
    }
    
    return (
        <CookiesProvider>
            <Provider store={store}>
                <ThemeContextProvider>
                    <IntlContextProvider>
                        <AppContextProvider>
                            <MembershipContextProvider>
                                <App />
                                <ToastContainer />
                            </MembershipContextProvider>
                        </AppContextProvider>
                    </IntlContextProvider>
                </ThemeContextProvider>
            </Provider>
        </CookiesProvider>        
    )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppRender />);


reportWebVitals();